import { render, staticRenderFns } from "./LoadingSplash.vue?vue&type=template&id=5e4955eb&"
import script from "./LoadingSplash.vue?vue&type=script&lang=ts&"
export * from "./LoadingSplash.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingSplash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports